// Index.vue === NotesWrapper.jsx
// Note.vue === Note.jsx
// Create.vue === NoteForm.jsx
// main.js === index.js

export const config = {
  apiKey: 'AIzaSyB1XNwzNhkOyJVU3Z3pfDzjUvthJoQXISk',
  authDomain: 'refuge-fed63.firebaseapp.com',
  databaseURL: 'https://refuge-fed63.firebaseio.com',
  storageBucket: 'refuge-fed63.appspot.com',
  messagingSenderId: '1040318935594',
};



// WEBPACK FOOTER //
// ./src/config.js